import axios from 'axios';
import qs from 'qs';

// ------------------- COURSE API ------------------- //
export const createArcade = (data: any) => axios.post('/api/v1/arcades', data);

export const updateArcadeById = (
  { arcadeId, data }: { arcadeId: string; data: any }, // NEW
) => axios.put(`/api/v1/arcades/${arcadeId}`, data);

export const submitArcade = (arcadeId: string) =>
  axios.post(`/api/v1/arcades/${arcadeId}/submit`);

export const publishArcade = (arcadeId: string) =>
  axios.post(`/api/v1/arcades/${arcadeId}/publish`);

export const archiveArcade = (arcadeId: string) =>
  axios.post(`/api/v1/arcades/${arcadeId}/archive`);

export const restoreArcade = (arcadeId: string) =>
  axios.post(`/api/v1/arcades/${arcadeId}/restore`);

export const removeArcade = (arcadeId: string) =>
  axios.delete(`/api/v1/arcades/${arcadeId}`);

export const getArcades = (params: Record<string, any>) =>
  axios.get(`/api/v1/arcades?${qs.stringify(params)}`);

export const getArcadeById = (arcadeId: string) =>
  axios.get(`/api/v1/arcades/${arcadeId}`);

export const getArcadesStats = () => axios.get('/api/v1/arcades/stats');

export const getArcadeStats = (arcadeId: string) =>
  axios.get(`/api/v1/arcades/${arcadeId}/stats`);

export const getArcadeStatsByStudent = ({
  arcadeId,
  studentId,
}: {
  arcadeId: string;
  studentId: string;
}) => axios.get(`/api/v1/arcades/${arcadeId}/stats/${studentId}`);

// ------------------- COURSE API ------------------- //

// ------------------- COURSE MODULES API ------------------- //

export const getArcadeModules = (arcadeId: string) =>
  axios.get(`/api/v1/arcades/${arcadeId}/modules`);

export const createArcadeModule = ({
  arcadeId,
  data,
}: {
  arcadeId: string;
  data: any;
}) => axios.post(`/api/v1/arcades/${arcadeId}/modules`, data);

export const updateArcadeModuleById = ({
  arcadeId,
  moduleId,
  data,
}: {
  arcadeId: string;
  moduleId: string;
  data: any;
}) => axios.put(`/api/v1/arcades/${arcadeId}/modules/${moduleId}`, data);

export const removeArcadeModuleById = ({
  arcadeId,
  moduleId,
}: {
  arcadeId: string;
  moduleId: string;
}) => axios.delete(`/api/v1/arcades/${arcadeId}/modules/${moduleId}`);

export const reorderArcadeModules = ({
  arcadeId,
  data,
}: {
  arcadeId: string;
  data: any;
}) => axios.post(`/api/v1/arcades/${arcadeId}/modules/reorder`, data);

// ------------------- COURSE MODULES API ------------------- //

// ------------------- COURSE LESSONS API ------------------- //

export const getArcadeLessons = (arcadeId: string) =>
  axios.get(`/api/v1/arcades/${arcadeId}/lessons`);

export const reorderArcadeLessons = ({
  arcadeId,
  data,
}: {
  arcadeId: string;
  data: any;
}) => axios.post(`/api/v1/arcades/${arcadeId}/lessons/reorder`, data);

export const getArcadeLessonById = ({
  arcadeId,
  lessonId,
}: {
  arcadeId: string;
  lessonId: string;
}) => axios.get(`/api/v1/arcades/${arcadeId}/lessons/${lessonId}`);

export const removeArcadeLessonById = ({
  arcadeId,
  lessonId,
}: {
  arcadeId: string;
  lessonId: string;
}) => axios.delete(`/api/v1/arcades/${arcadeId}/lessons/${lessonId}`);
